<app-form-group
  [control]="control"
  [name]="name"
  type="file"
  [label]="label"
  (change)="fileUploadChanged($event)"
></app-form-group>
